import { useEffect } from "react";
import Routes from "./routes/Routes";
import { requestNotificationPermission, registerServiceWorkerAndSubscribe } from "./helpers/pushNotifications";

const App = () => {
  useEffect(() => {
    async function setupNotifications() {
      await requestNotificationPermission();
      await registerServiceWorkerAndSubscribe();
    }
    setupNotifications();
  }, []);

  return <Routes />;
};

export default App;
